import * as React from 'react'
import NotificationsStore, { NotificationEntity } from '../../../Stores/NotificationsStore'
import { withRouter } from 'react-router'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExternalDataStore from '../../../Stores/ExternalDataStore'
import { inject, observer } from 'mobx-react'
import ExternalDataCreditInfoItemsView
    from '../../PartialViews/ExternalData/ExternalDataViews/ExternalDataCreditInfoItemsView'

export interface IExternalDataPagePassportProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    externalDataStore: ExternalDataStore
    notificationsStore: NotificationsStore
}

@inject('localizationStore')
@inject('httpActionsService')
@inject('externalDataStore')
@inject('notificationsStore')

@observer
class ExternalDataSearchByPassportPage extends React.Component<IExternalDataPagePassportProps> {

    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        if (this.props['match']!['params']['passport']) {
            this.props.httpActionsService!
                .getExternalDataByPassport(this.props['match']!['params']['passport'])
        } else {
            this.props.notificationsStore
                .addAlert(
                    new NotificationEntity(
                        'danger',
                        this.props.localizationStore!.t('no passport number in query params!')
                    )
                )
        }
    }

    render() {
        const { externalDataStore, localizationStore } = this.props

        if (externalDataStore!.isError) {
            return (<div>{this.props.localizationStore!.t('No data text')}</div>)
        }

        const data = externalDataStore!.getData!

        return (
            <div className="external-data-page">
                {!!data
                    && data.creditInfoItems.length
                    ?
                    <ExternalDataCreditInfoItemsView
                        creditInfoItems={data.creditInfoItems}
                        headerText={localizationStore!.t!('Get external data by phone')}
                    />
                    : this.props.localizationStore!.t('No data text')}
            </div>
        )
    }
}

export default withRouter(ExternalDataSearchByPassportPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalDataSearchByPassportPage.tsx